import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { RenderElement } from "@up/form";
import { range } from "@up/ui";

export const HighSchoolGraduationYearName = "high-school-graduation-year";

export function HighSchoolGraduationYear({
  label = "High School Graduation Year",
}: {
  label?: string;
}) {
  const { control, register } = useFormContext();
  const { errors } = useFormState();
  const formValues = useWatch();

  const VALIDATION = { presence: true };
  const CURRENT_YEAR = new Date().getFullYear();
  const OPTIONS = range(CURRENT_YEAR + 7, CURRENT_YEAR - 72, -1);

  return (
    <RenderElement
      control={control}
      element={{
        _id: HighSchoolGraduationYearName,
        type: "select",
        label: label,
        name: HighSchoolGraduationYearName,
        options: OPTIONS,
        validate: VALIDATION,
        meta: {
          type: "year",
        },
      }}
      errors={errors}
      formValues={formValues}
      register={register}
      wrapperProps={{ className: "mb-8" }}
    />
  );
}
